const postMessageTypes = {
  USER_CANCELLED: 'USER_CANCELLED',
  SHOW_FRAME: 'SHOW_FRAME',
  HIDE_FRAME: 'HIDE_FRAME',
  CLOSED_WINDOW: 'CLOSED_WINDOW',
  MANAGE_WINDOW: 'MANAGE_WINDOW',
  MANAGE_WINDOW_FINISHED: 'MANAGE_WINDOW_FINISHED',
  CLOSE_ALL_WINDOW: 'CLOSE_ALL_WINDOW',
  CLOSE_ALL_WINDOW_FINISHED: 'CLOSE_ALL_WINDOW_FINISHED',
  LOGIN_BUTTON_CLICKED: 'LOGIN_BUTTON_CLICKED',
  RESTART_ORDER: 'RESTART_ORDER',
  CONNECT_LOADED: 'CONNECT_LOADED',
  BROKER_TWEET: 'BROKER_TWEET',
  USER_SIGNUP: 'USER_SIGNUP',
  LOGIN_BUTTON_CLICKED_CONSENT_REQUIRED: 'LOGIN_BUTTON_CLICKED_CONSENT_REQUIRED',
  UPDATE_GATEWAY_NAME: 'UPDATE_GATEWAY_NAME',
};

export default postMessageTypes;



// WEBPACK FOOTER //
// ./constants/messageTypes.js